(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer-mega-shop"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    (event) => {
      const item = event.target;
      if (!item.classList?.contains('menu-drawer__mega-accordion-item') || !item.open) return;

      const accordion = item.closest('.menu-drawer__mega-accordion');
      if (!accordion) return;

      accordion.querySelectorAll('.menu-drawer__mega-accordion-item[open]').forEach((openItem) => {
        if (openItem !== item) openItem.removeAttribute('open');
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    const escapeHtml = (str) => {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    const SWAP_MS = 220;

    const animatePanelSwap = (container, renderFn) => {
      if (!container) return;

      const hasContent = container.querySelector('.mega-menu__product-card, .mega-menu__article-card');

      if (!hasContent) {
        renderFn();
        container.classList.add('is-visible');
        container.classList.remove('is-swapping');
        return;
      }

      container.classList.add('is-swapping');
      container.classList.remove('is-visible');

      window.setTimeout(() => {
        renderFn();
        container.classList.remove('is-swapping');
        void container.offsetWidth;
        container.classList.add('is-visible');
      }, SWAP_MS);
    };

    const collectionsEl = document.getElementById('MegaMenuCollectionsData');
    if (collectionsEl) {
      let collectionProducts = {};
      try {
        collectionProducts = JSON.parse(collectionsEl.textContent);
      } catch (e) {
        collectionProducts = {};
      }

      const buildProductMarkup = (products) => {
        if (!products || !products.length) {
          return '<p class="mega-menu__empty">No products found</p>';
        }

        return products
          .map((product, index) => {
            const tone = (index % 4) + 1;
            const badge = product.isNew ? '<span class="mega-menu__product-badge">New</span>' : '';
            const image = product.image
              ? `<img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy" width="200" height="200">`
              : '';
            const subtitle = product.subtitle
              ? `<p class="mega-menu__product-subtitle">${escapeHtml(product.subtitle)}</p>`
              : '';

            return `
              <a href="${product.url}" class="mega-menu__product-card">
                <div class="mega-menu__product-card-media mega-menu__product-card-media--tone-${tone}">
                  ${badge}
                  ${image}
                </div>
                <h4 class="mega-menu__product-title">${escapeHtml(product.title)}</h4>
                ${subtitle}
              </a>`;
          })
          .join('');
      };

      document.querySelectorAll('.mega-menu--shop').forEach((menu) => {
        const menuId = menu.id.replace('Details-HeaderMenu-', '');
        const panelData = collectionProducts[menuId];
        const container = menu.querySelector('[data-mega-products-panel]');
        const sidebarLinks = menu.querySelectorAll('.mega-menu__sidebar-link[data-collection-handle]');

        sidebarLinks.forEach((link) => {
          if (!link.hasAttribute('data-collection-handle')) return;

          const activate = () => {
            sidebarLinks.forEach((l) => l.classList.remove('is-active'));
            link.classList.add('is-active');
            const handle = link.getAttribute('data-collection-handle');
            if (!panelData || !panelData[handle]) return;

            animatePanelSwap(container, () => {
              container.innerHTML = buildProductMarkup(panelData[handle]);
            });
          };

          link.addEventListener('mouseenter', activate);
          link.addEventListener('focus', activate);
        });
      });
    }

    const learnEl = document.getElementById('MegaMenuLearnData');
    if (learnEl) {
      let learnPanels = {};
      try {
        learnPanels = JSON.parse(learnEl.textContent);
      } catch (e) {
        learnPanels = {};
      }

      const buildArticleMarkup = (articles) => {
        if (!articles || !articles.length) {
          return '<p class="mega-menu__empty">No articles found</p>';
        }

        return articles
          .map((article) => {
            const image = article.image
              ? `<img src="${article.image}" alt="${escapeHtml(article.title)}" loading="lazy" width="300" height="400">`
              : '';
            const excerpt = article.excerpt
              ? `<p class="mega-menu__article-excerpt">${escapeHtml(article.excerpt)}</p>`
              : '';

            return `
              <a href="${article.url}" class="mega-menu__article-card">
                <div class="mega-menu__article-card-media">${image}</div>
                <h4 class="mega-menu__article-title">${escapeHtml(article.title)}</h4>
                ${excerpt}
              </a>`;
          })
          .join('');
      };

      document.querySelectorAll('.mega-menu--learn').forEach((menu) => {
        const menuId = menu.id.replace('Details-HeaderMenu-', '');
        const panelData = learnPanels[menuId];
        const container = menu.querySelector('[data-mega-articles-panel]');
        const viewAllLink = menu.querySelector('[data-mega-learn-view-all]');
        const sidebarLinks = menu.querySelectorAll('.mega-menu__sidebar-link[data-learn-key]');

        sidebarLinks.forEach((link) => {
          const activate = () => {
            sidebarLinks.forEach((l) => l.classList.remove('is-active'));
            link.classList.add('is-active');
            const key = link.getAttribute('data-learn-key');
            const entry = panelData && panelData[key];

            if (entry) {
              animatePanelSwap(container, () => {
                container.innerHTML = buildArticleMarkup(entry.articles);
              });

              if (viewAllLink && entry.viewAllUrl) {
                viewAllLink.href = entry.viewAllUrl;
              }
            }

            if (viewAllLink && link.hasAttribute('data-view-all-url')) {
              viewAllLink.href = link.getAttribute('data-view-all-url');
            }
          };

          link.addEventListener('mouseenter', activate);
          link.addEventListener('focus', activate);
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
